<!-- MOLECULE: DrawerHeaderRail.vue -->

<script setup lang="ts">
//
// ============================================================================
// PROPS & EMITS
// ============================================================================
//

interface Props {
  appLogoRailMode?: string | null;
}

const props = withDefaults(defineProps<Props>(), {
  appLogoRailMode: null,
});

//
// ============================================================================
// COMPOSABLES
// ============================================================================
//

const logoSrc = useAssetPath(
  "/app-logo-primary.png",
  toRef(() => props.appLogoRailMode),
);
</script>

<template>
  <v-list density="compact" nav>
    <v-list-item class="px-1">
      <!-- <v-img :src="logoSrc" :width="30" :height="30" alt="App Logo" /> -->
      <v-icon icon="mdi-microscope" size="30" color="primary" />
    </v-list-item>
  </v-list>
</template>
